import loadable from '@loadable/component';

// 懒加载组件
const CstStatementManagement = loadable(() => import('./cstStatementManagement/CstStatementManagement'));
const CstStatementModify = loadable(() => import('./cstStatementManagement/cstStatementModify/CstStatementModify'));
const CstStatementInvoiceManagement = loadable(() => import('./cstStatementManagement/cstStatementInvoiceManagement/CstStatementInvoiceManagement'));
const InvoiceManagement = loadable(() => import('./invoiceManagement/InvoiceManagement'));
const InvoiceModify = loadable(() => import('./invoiceManagement/invoiceModify/InvoiceModify'));
const CstStatementConfirmation = loadable(() => import('./cstStatementConfirmation/CstStatementConfirmation'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmation/cstStatementConfirmationModify/CstStatementConfirmationModify'));
const PaymentRequestManagement = loadable(() => import('./paymentRequestManagement/PaymentRequestManagement'));
const PaymentRequestModify = loadable(() => import('./paymentRequestManagement/paymentRequestModify/PaymentRequestModify'));
const PaymentRequestDetailModify = loadable(() => import('./paymentRequestManagement/paymentRequestDeatilModify/PaymentRequestDetailModify'));
const DeliveryBalanceQuery = loadable(() => import('./deliveryBalanceQuery/DeliveryBalanceQuery'));

export default [
  {
    path: '/CstStatementManagement',
    component: CstStatementManagement
  },
  {
    path: '/CstStatementModify',
    component: CstStatementModify
  },
  {
    path: '/CstStatementInvoiceManagement',
    component: CstStatementInvoiceManagement
  },
  {
    path: '/InvoiceManagement',
    component: InvoiceManagement
  },
  {
    path: '/InvoiceModify',
    component: InvoiceModify
  },
  {
    path: '/CstStatementConfirmation',
    component: CstStatementConfirmation
  },
  {
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  },
  {
    path: '/PaymentRequestManagement',
    component: PaymentRequestManagement
  },
  {
    path: '/PaymentRequestModify',
    component: PaymentRequestModify
  },
  {
    path: '/PaymentRequestDetailModify',
    component: PaymentRequestDetailModify
  },
  {
    // 242306销售结算对账单
    path: '/DeliveryBalanceQuery',
    component: DeliveryBalanceQuery
  }
];
